<template>
    <cases :datasource="newCases" :isLoading="loading"/>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import Cases from './components/Cases';

export default {
  components: {
    Cases
  },
  data () {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters(['newCases'])
  },
  async mounted () {
    this.CLEAR_DATA();

    this.loading = true;
    
    let cases = await this.GetAllTicket();
    this.loading = false;

    let sups = await this.GetAllTechnicalUser();
    let supsId = sups.map(a => Number(a.VehicleId)).filter(v => v);
    let wps = await this.VehicleStatusRequest({ VehicleIds: supsId });
    if (wps) { this.SET_WAYPOINT_TO_SUPPORTERS(wps) }
    else { window.getApp.showMessage('Không lấy được vị của các nhân viên kỹ thuật', 'error') } 
    if (cases.length > 0) { this.SET_CASE_TO_SUPPORTERS() }

  },
  methods: {
    ...mapActions(['GetSupporters', 'GetAllCases', 'GetNewCases', 'VehicleStatusRequest', 'GetAllTicket', 'GetAllTechnicalUser']),
    ...mapMutations(['CLEAR_DATA', 'SET_CASE_TO_SUPPORTERS', 'SET_WAYPOINT_TO_SUPPORTERS'])
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/dispatch/Index.vue